import React from 'react';

import usePage from 'app/hook/common/usePage';
import PagePortal from 'app/components/common/PagePortal';

import classNames from 'classnames/bind';
import styles from './PageComm.module.scss';

const cx = classNames.bind(styles);

function PageComm({ children }) {
	const { hideLayout, pageClass } = usePage();

	return (
		<PagePortal>
			<div className={cx('page', { view: hideLayout }, { on: pageClass === 'on' }, { end: pageClass === 'end' })}>{children}</div>
		</PagePortal>
	);
}

export default PageComm;
